module.exports = __webpack_public_path__ + "img/微信.126363a9.png";